<template>
  <main class="p-4 pt-16 lg:text-2xl" v-if="about">

      <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-8 py-4 lg:py-8">
            <div class="lg:col-span-1 space-y-4 lg:space-y-8 max-w-4xl" v-html="about.text"></div>
            <div class="lg:col-span-1">
                  <div class="space-y-4 lg:space-y-8 pb-4 lg:pb-8mb-4 lg:mb-0">
                        <img v-for="(img, index) in about.images" :key="index" class="max-w-4xl w-full lazyload" :src="img.thumb" :srcset="img.srcset" alt="" />
                  </div>
                  <div v-for="(year, index) in about.timeline" :key="index" class="grid grid-cols-smallcustom lg:grid-cols-custom gap-4">
                        <div>{{ year.year }}</div>
                        <div class="">{{ year.text }}</div>
                  </div>
            </div>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-8 pb-4 lg:pb-8">
            <div class="space-y-4 lg:space-y-8">
                  <div class="">CONTACT</div>
                  <div class="space-y-4 lg:space-y-8" v-html="about.contact"></div>
                  <div v-if="about.showroom" class="space-y-4 lg:space-y-8" v-html="about.showroom"></div>
            </div>
            <div class="hidden lg:block"></div>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-8 pb-4 lg:pb-8">
            <div class="space-y-4 lg:space-y-8 text-sm lg:text-base leading-tight lg:leading-tight" v-html="about.colophon"></div>
      </div>
      
  </main>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "about",
  metaInfo() {
    return {
      title: "– About",
      meta: [
        {
          description: this.about.text,
        },
      ],
    };
  },
  computed: mapState(["about"]),
};
</script>
